import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { ICellRendererAngularComp } from "@bfx/ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
  selector: "fill-percent-renderer",
  templateUrl: "./html/FillPercentRenderer.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FillPercentRenderer implements ICellRendererAngularComp {
  public showBar: boolean;
  public value: string;
  public valueFormatted: string;

  private previous: { showBar: boolean; value: string; valueFormatted: string };

  constructor(public cd: ChangeDetectorRef) {
    this.previous = {
      showBar: this.showBar,
      value: this.value,
      valueFormatted: this.valueFormatted,
    };
  }

  // called on init
  agInit(params: ICellRendererParams): void {
    this.doVal(params);
  }

  doVal(params: ICellRendererParams): boolean {
    this.previous.showBar = this.showBar;
    this.previous.value = this.value;
    this.previous.valueFormatted = this.valueFormatted;

    this.showBar = params?.valueFormatted !== "-";
    this.value = params.value;
    this.valueFormatted = params.valueFormatted;

    return (
      this.showBar !== this.previous.showBar ||
      this.value !== this.previous.value ||
      this.valueFormatted !== this.previous.valueFormatted
    );
  }

  // called when the cell is refreshed
  refresh(params: ICellRendererParams): boolean {
    if (this.doVal(params)) {
      this.cd.markForCheck();
    }

    return true;
  }
}
